import { useState } from 'react';

const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function CallToAction() {
	const [formData, setFormData] = useState({
		name: '',
		email: '',
		message: '',
	});
	const [message, setMessage] = useState('');
	const [status, setStatus] = useState('idle');

	const handleChange = (event) => {
		const { name, value } = event.target;
		setFormData((prev) => ({ ...prev, [name]: value }));
	};

	const handleSubmit = (event) => {
		event.preventDefault();

		if (!formData.name.trim()) {
			setStatus('error');
			setMessage('Please enter your full name.');
			return;
		}

		if (!formData.email.trim()) {
			setStatus('error');
			setMessage('Please enter your email address.');
			return;
		}

		if (!emailPattern.test(formData.email.trim())) {
			setStatus('error');
			setMessage('Please enter a valid email address.');
			return;
		}

		if (!formData.message.trim() || formData.message.trim().length < 10) {
			setStatus('error');
			setMessage('Please enter your project requirement (minimum 10 characters).');
			return;
		}

		setStatus('success');
		setMessage('Thank you. Your message has been received. Our team will contact you shortly.');
		setFormData({
			name: '',
			email: '',
			message: '',
		});
	};

	return (
		<section id="contact" className="py-16 lg:py-20">
			<div className="mx-auto max-w-3xl rounded-2xl bg-white p-5 shadow-lg ring-1 ring-slate-200 sm:p-6">
				<div>
						<h2 className="text-2xl font-bold text-slate-900">Contact Us</h2>
						<p className="mt-1 text-sm text-slate-600">
							Send your requirement. We will respond quickly.
						</p>

						<form onSubmit={handleSubmit} className="mt-4 grid gap-3 rounded-xl bg-slate-50 p-3 ring-1 ring-slate-200 md:grid-cols-2">
						<input
							name="name"
							type="text"
							value={formData.name}
							onChange={handleChange}
							placeholder="Full Name"
							className="rounded-lg border border-slate-300 bg-white px-3.5 py-2.5 text-sm text-slate-900 outline-none transition-all duration-300 placeholder:text-slate-500 focus:border-cyan-500 focus:ring-2 focus:ring-cyan-200"
						/>
						<input
							name="email"
							type="email"
							value={formData.email}
							onChange={handleChange}
							placeholder="Email"
							className="rounded-lg border border-slate-300 bg-white px-3.5 py-2.5 text-sm text-slate-900 outline-none transition-all duration-300 placeholder:text-slate-500 focus:border-cyan-500 focus:ring-2 focus:ring-cyan-200"
						/>
						<textarea
							name="message"
							value={formData.message}
							onChange={handleChange}
							placeholder="Project requirement"
							rows={4}
							className="rounded-lg border border-slate-300 bg-white px-3.5 py-2.5 text-sm text-slate-900 outline-none transition-all duration-300 placeholder:text-slate-500 focus:border-cyan-500 focus:ring-2 focus:ring-cyan-200 md:col-span-2"
						/>
						<button
							type="submit"
							className="inline-flex justify-center rounded-lg bg-cyan-600 px-6 py-2.5 text-sm font-semibold text-white transition-all duration-300 hover:bg-cyan-700 focus:outline-none focus:ring-2 focus:ring-cyan-200 md:col-span-2"
						>
							Send Message
						</button>
						</form>

						{status !== 'idle' && (
							<p
								className={`mt-3 text-sm font-medium ${
									status === 'success' ? 'text-emerald-600' : 'text-rose-600'
								}`}
								role="status"
								aria-live="polite"
							>
								{message}
							</p>
						)}

						<p className="mt-3 text-xs text-slate-500">admin@viance.co.in • 9823272353 • Pune</p>
				</div>
			</div>
		</section>
	);
}

export default CallToAction;
